// extracted by mini-css-extract-plugin
module.exports = {"header":"_6OmRMcO6","content":"_dJj2nGgx","info":"_wSj0qQD2","link":"_yITLRxvu","footer":"_Zq4I-HBe"};